/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable implicit-arrow-linebreak */
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import * as yup from 'yup';

dayjs.extend(customParseFormat);

export const phoneRegExp = /^\d{10}$/;

export const contactFormSchema = yup.object().shape({
  address: yup.string(),
  content: yup.string().required('Bạn chưa nhập nội dung'),
  email: yup.string(),
  name: yup.string().required('Bạn chưa nhập họ tên'),
  phone: yup
    .string()
    .matches(
      /(03|05|07|08|09|01[2|6|8|9])+([0-9]{8})\b/,
      'Số điện thoại không hợp lệ'
    ),
  attachment: yup.string(),
});

export const aiProfileSchema = yup.object().shape({
  agentName: yup
    .string()
    .required('This field is required')
    .matches(
      /^[a-zA-Z0-9\s\u00C0-\u1EF9\u0102\u0110\u0128\u0168\u01A0\u01AF\u1EA0-\u1EF9]*$/,
      'Invalid name format. Please use letters only.'
    ),
  description: yup.string().max(200, 'Maximum 200 characters'),
  instruction: yup.string().nullable(),
  language: yup
    .object()
    .required('This field is required')
    .required('This field is required'),
  avatar: yup.string().required('Avatar is required'),
  mainColor: yup.string().required('Please choose color'),
  // mainColor: yup.string().required('Please choose color'),
  bgType: yup
    .number()
    .required('Please choose background type'),
  bgColorFirst: yup.string().when('bgType', {
    is: 1,
    then: (schema) => schema.required('First background color is required'),
    otherwise: (schema) => schema.notRequired(),
  }),

  bgColorSecond: yup.string().when('bgType', {
    is: 1,
    then: (schema) => schema.required('Second background color is required'),
    otherwise: (schema) => schema.notRequired(),
  }),

  bgFile: yup.mixed().when('bgType', {
    is: 2,
    then: (schema) =>
      schema.required('Background image is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export const agentCustomizationSchema = yup.object().shape({
  // only accept numbers, spaces, and alphabets
  name: yup
    .string()
    .required('This field is required')
    .matches(
      /^[a-zA-Z0-9\s\u00C0-\u1EF9\u0102\u0110\u0128\u0168\u01A0\u01AF\u1EA0-\u1EF9]*$/,
      'Invalid name format. Please use letters only.'
    ),
  avatar: yup.string().required('Avatar is required'),
  processMsgType: yup
    .number()
    .transform((value, originalValue) =>
      (Number.isNaN(Number(originalValue)) ? undefined : Number(originalValue)))
    .required('Processing type is required'),
  processCustomMsg: yup
    .string()
    .max(60, 'Maximum 60 characters')
    .when('processMsgType', {
      is: 2,
      then: (schema) => schema.required('This field is required.'),
      otherwise: (schema) => schema.notRequired(),
    }),
  shortDescription: yup.string().max(200, 'Maximum 200 characters'),
  anonymousWelcomeMsg: yup.string(),
  userWelcomeMsg: yup.string().max(500, 'Maximum 500 characters'),
  userOnboardMsg: yup.string().max(500, 'Maximum 500 characters'),
  bothWelcomeMsg: yup.string().max(500, 'Maximum 500 characters'),
  bothOnboardMsg: yup.string().max(500, 'Maximum 500 characters'),
  mainColor: yup.string().required('Please choose color'),
  bgType: yup
    .number()
    .required(),

  bgColorFirst: yup.string().when('bgType', {
    is: 1,
    then: (schema) => schema.required('Please choose first background color'),
    otherwise: (schema) => schema.notRequired(),
  }),

  bgColorSecond: yup.string().when('bgType', {
    is: 1,
    then: (schema) => schema.required('Please choose second background color'),
    otherwise: (schema) => schema.notRequired(),
  }),

});

export const customerTagSchema = yup.object().shape({
  name: yup
    .string()
    .required('Please input information')
  // .matches(/^[a-zA-Z0-9]+$/, 'Only letters and numbers are allowed'),
});

export const createUserSchema = yup.object().shape({
  name: yup.string().required('Please input information'),
  email: yup
    .string()
    .email('Email is invalid')
    .required('Please input information'),
  phone: yup
    .string()
    .matches(
      /(03|05|07|08|09|01[2|6|8|9])+([0-9]{8})\b/,
      'Invalid phone number'
    )
    .required('Please input information'),
});

export const crawLinkSchema = yup.object().shape({
  link: yup
    .string()
    .required('Please input information')
    .matches(
      /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?(\?.*)?$/,
      'Must be a valid link format'
    ),
  type: yup.number().required('Please input information'),
});

export const testSMSSchema = yup.object().shape({
  phone: yup
    .string()
    .matches(/^(0[1|3|5|7|8|9])[0-9]{8}$/, 'Invalid phone number')
    .required('Please input information'),
});

export const testMailSchema = yup.object().shape({
  mail: yup
    .string()
    .email('Email is invalid')
    .required('Please input information'),
  providerId: yup.number().required('Please input information'),
});

export const zaloIntegrationSchema = yup.object().shape({
  oaId: yup.string().required('Please input information'),
});

export const settingInstructionSchema = yup.object().shape({
  instruction: yup.string().optional(),
  bothWelcomeMsg: yup.string().max(500, 'Maximum 500 characters').optional(),
  anonymousWelcomeMsg: yup.string().max(500, 'Maximum 500 characters').optional(),
  userWelcomeMsg: yup.string().max(500, 'Maximum 500 characters').optional(),
  suggestedMsg: yup.array().of(yup.string()).max(6, 'Maximum 6 messages allowed.').optional(),
  processMsgType: yup.number().optional(),
  processCustomMsg: yup.string().max(60, 'Maximum 60 characters').when('processMsgType', {
    is: 2,
    then: (schema) => schema.required('Processing message is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  includeAi: yup.boolean().optional(),
  tools: yup.array().optional(),
});

export const addAIActionSchema = yup.object().shape({
  action: yup
    .string()
    .required('Please input information')
    .test('starts-with-dot-slash', 'Command must start with /', (value) =>
      (value ? value.startsWith('/') : false))
    .test('no-spaces', 'Command cannot contain spaces', (value) =>
      (value ? !/\s/.test(value) : false))
    .max(30),
  saveResponseVariable: yup.string().optional(),
});

export const addAIQuestionSchema = yup.object().shape({
  question: yup.string().required('Please input information'),
  responseType: yup.string().required('Please input information'),
  variable: yup.string().optional(),
});

export const addAIConditionSchema = yup.object().shape({
  type: yup.string().required('Please input information'),
  timeout: yup
    .number()
    .typeError('Timeout must be a number')
    .required('Please input information')
    .max(3600, 'Timeout must be less than 3600')
    .min(1, 'Timeout must be greater than or equal to 1'),
  saveResponseVariable: yup.string().optional(),
  content: yup.string().optional(),
});

export const endActionSchema = yup.object().shape({
  content: yup.string(),
});

export const webHookSchema = yup.object().shape({
  endPoint: yup.string().required('Please input information'),
  method: yup.string().required('Please choose a method'),
  headers: yup
    .array()
    .of(
      yup.object().shape({
        key: yup.string().required('Enter Key'),
        value: yup.string().required('Enter Value'),
      })
    )
    .min(1, 'Please add at least one header')
    .test('unique-header-keys', '', (headers) => {
      if (!headers) return true;
      const seen = new Set();
      const errors: yup.ValidationError[] = [];
      headers.forEach((h, i) => {
        const key = h.key?.trim().toLowerCase();
        if (key && seen.has(key)) {
          errors.push(new yup.ValidationError('Duplicate key', h.key, `headers[${i}].key`));
        } else if (key) {
          seen.add(key);
        }
      });
      return errors.length > 0 ? new yup.ValidationError(errors) : true;
    }),
  payload: yup
    .array()
    .of(
      yup.object().shape({
        key: yup.string().required('Enter Key'),
        value: yup.string().required('Enter Value'),
      })
    )
    .min(1, 'Please add at least one payload')
    .test('unique-payload-keys', '', (payload) => {
      if (!payload) return true;
      const seen = new Set();
      const errors: yup.ValidationError[] = [];
      payload.forEach((p, i) => {
        const key = p.key?.trim().toLowerCase();
        if (key && seen.has(key)) {
          errors.push(new yup.ValidationError('Duplicate key', p.key, `payload[${i}].key`));
        } else if (key) {
          seen.add(key);
        }
      });
      return errors.length > 0 ? new yup.ValidationError(errors) : true;
    }),
});

export const apiSchema = yup.object().shape({
  endPoint: yup.string().required('Please input information'),
  method: yup.string().required('Please input information'),
  headers: yup
    .array()
    .of(
      yup.object().shape({
        key: yup.string().required('Enter Key'),
        value: yup.string().required('Enter Value'),
      })
    )
    .min(1, 'Please add at least one header')
    .test('unique-header-keys', '', (headers) => {
      if (!headers) return true;
      const seen = new Set();
      const errors: yup.ValidationError[] = [];
      headers.forEach((h, i) => {
        const key = h.key?.trim().toLowerCase();
        if (key && seen.has(key)) {
          errors.push(new yup.ValidationError('Duplicate key', h.key, `headers[${i}].key`));
        } else if (key) {
          seen.add(key);
        }
      });
      return errors.length > 0 ? new yup.ValidationError(errors) : true;
    }),
  payload: yup
    .array()
    .of(
      yup.object().shape({
        key: yup.string().required('Enter Key'),
        value: yup.string().required('Enter Value'),
      })
    )
    .min(1, 'Please add at least one payload')
    .test('unique-payload-keys', '', (payload) => {
      if (!payload) return true;
      const seen = new Set();
      const errors: yup.ValidationError[] = [];
      payload.forEach((p, i) => {
        const key = p.key?.trim().toLowerCase();
        if (key && seen.has(key)) {
          errors.push(new yup.ValidationError('Duplicate key', p.key, `payload[${i}].key`));
        } else if (key) {
          seen.add(key);
        }
      });
      return errors.length > 0 ? new yup.ValidationError(errors) : true;
    }),
  response: yup
    .array()
    .of(
      yup.object().shape({
        key: yup.string().required('Enter Key'),
        saveResponseVariable: yup.string().required('Enter Value'),
      })
    )
    .min(1, 'Please add at least one response')
    .test('unique-response-keys', '', (response) => {
      if (!response) return true;
      const seen = new Set();
      const errors: yup.ValidationError[] = [];
      response.forEach((r, i) => {
        const key = r.key?.trim().toLowerCase();
        if (key && seen.has(key)) {
          errors.push(new yup.ValidationError('Duplicate key', r.key, `response[${i}].key`));
        } else if (key) {
          seen.add(key);
        }
      });
      return errors.length > 0 ? new yup.ValidationError(errors) : true;
    }),
  timeout: yup
    .number()
    .typeError('Timeout must be a number')
    .required('Please input information')
    .max(3600, 'Timeout must be less than 3600')
    .min(1, 'Timeout must be greater than or equal to 1'),
});

export const sendMailSchema = yup.object().shape({
  type: yup
    .string()
    .oneOf(['sendMailEmail', 'sendMailVariable'])
    .required('Please choose a type'),
  sendmailTo: yup.string().when('type', {
    is: 'sendMailEmail',
    then: (schema) =>
      schema.required('Please input email').email('Email invalid'),
    otherwise: (schema) => schema.required('Please input information'),
  }),
  subject: yup.string().required('Please input information'),
  body: yup.string().required('Please input information'),
  providerId: yup.number().required('Please input information'),
  emailTemplateId: yup.number().required('Please input information'),
});

export const createGenerateSchema = yup.object().shape({
  instruction: yup.string().required('Please input information'),
  saveResponseVariable: yup.string().required('Please input information'),
  items: yup.array().when('type', {
    is: (val: string) => val === 'dataSource' || val === 'dataTag',
    then: (schema) => schema.min(1, 'Please select at least one item').required('This field is required'),
    otherwise: (schema) => schema.optional(),
  }),
  type: yup.string().required('Please input information'),
  aiResponseType: yup
    .string()
    .when('aiActionType', {
      is: '2',
      then: (schema) => schema.required('Please select response type'),
      otherwise: (schema) => schema.notRequired(),
    }),
  content: yup.string().when('aiResponseType', {
    is: 'json',
    then: (schema) =>
      schema
        .required('This field is required')
        .test('valid-json', 'Invalid JSON format', (value) => {
          if (!value) return false;
          try {
            JSON.parse(value);
            return true;
          } catch {
            return false;
          }
        }),
    otherwise: (schema) => schema.notRequired(),
  }),
  responseType: yup.string().required('Please input information'),
});

export const sendMessageSchema = yup.object().shape({
  content: yup.string().required('Please input information'),
  messageFileType: yup.string().optional(),
  videoURL: yup.string().when('messageFileType', {
    is: 'messageVideo',
    then: (schema) =>
      schema
        .required('Please enter a video URL')
        .url('Please enter a valid URL'),
    otherwise: (schema) => schema.notRequired(),
  }),
  saveResponseVariable: yup.string().when(['messageFileType', 'fileResource'], {
    is: (messageFileType: string, fileResource: string) =>
      messageFileType === 'messageFile' && fileResource === 'external',
    then: (schema) => schema.required('Please input information'),
    otherwise: (schema) => schema.optional(),
  }),
  fileResource: yup.string().optional(),
});

export const requestDemoSchema = yup.object({
  fullName: yup
    .string()
    .matches(
      /^[A-Za-zÀ-ỹà-ỹĀ-žƀ-ƶƸ-ȳ\s]+$/,
      'Full name contains invalid characters'
    )
    .min(2, 'Min 2 characters')
    .max(30, 'Max 30 characters')
    .required('Full name is required'),
  phone: yup
    .string()
    .required('Phone is required')
    .trim()
    .matches(phoneRegExp, 'Invalid phone number format'),
  email: yup
    .string()
    .required('Email is required')
    .email('Please enter a valid email address.'),
  role: yup.string(),
  companyName: yup.string(),
  note: yup
    .string()
    .max(
      500,
      'Oops! That’s too long. Messages must be 500 characters or fewer.'
    ),
});

export const freeTrialSchema = yup.object().shape({
  fullName: yup
    .string()
    .matches(
      /^[A-Za-zÀ-ỹà-ỹĀ-žƀ-ƶƸ-ȳ\s]+$/,
      'Full name contains invalid characters'
    )
    .min(2, 'Min 2 characters')
    .max(30, 'Max 30 characters')
    .required('Full name is required'),
  phone: yup
    .string()
    .required('Phone is required')
    .trim()
    .matches(phoneRegExp, 'Invalid phone number format'),
  email: yup
    .string()
    .required('Email is required')
    .email('Please enter a valid email address.'),
});

export const askQuestinoSchema = yup.object().shape({
  type: yup.string().required('Please choose response type'),
  content: yup.string().required('Please input information'),
  saveResponseVariable: yup.string().optional().nullable(),
  items: yup
    .array()
    .of(yup.string().trim().required('Option cannot be empty'))
    // eslint-disable-next-line func-names
    .test(
      'required-if-option',
      'Please add at least one option',
      (value, { parent }) => {
        const { type } = parent;
        if (type === 'questionOption') {
          return Array.isArray(value) && value.length > 0;
        }
        return true;
      }
    ),
});

export const anotherActionSchema = yup.object().shape({
  actionName: yup.string().required('Please input information'),
  passContext: yup.array().of(yup.string()).optional(),
});

export const saveActionSchema = yup.object().shape({
  name: yup.string().required('Action name is required'),
  icon: yup.string().required('Please input information'),
  description: yup.string().required('Please input information'),
  aiActType: yup.number().optional(),
  autoTrigger: yup.boolean(),
  autoDescription: yup.string().when('aiActType', {
    is: 1,
    then: (schema) =>
      schema
        .trim()
        .required('Please input information')
        .min(200, 'Detailed description must be at least 200 characters'),
    otherwise: (schema) => schema.optional(),
  }),
  autoKeyword: yup.string().when('aiActType', {
    is: 1,
    then: (schema) => schema.trim().required('Please input information'),
    otherwise: (schema) => schema.optional(),
  }),
});

export const updateActionSchema = yup.object().shape({
  name: yup.string().required('Please input information'),
  icon: yup.string().optional().nullable(),
  description: yup.string().optional().nullable(),
  aiActType: yup.number().optional(),
  autoTrigger: yup.boolean(),
  autoDescription: yup.string().when('aiActType', {
    is: 1,
    then: (schema) =>
      schema
        .trim()
        .required('Please input information')
        .min(200, 'Detailed description must be at least 200 characters'),
    otherwise: (schema) => schema.optional(),
  }),
  autoKeyword: yup.string().when('aiActType', {
    is: 1,
    then: (schema) => schema.trim().required('Please input information'),
    otherwise: (schema) => schema.optional(),
  }),
});

const individualInfoSchema = yup.object({
  nationalId: yup
    .string()
    .required('National ID is required')
    .matches(/^[a-zA-Z0-9]*$/, 'Only letters and numbers are allowed'),
  fullName: yup
    .string()
    .required('Full name is required')
    .min(2, 'Full name must be at least 2 characters')
    .max(50, 'Full name must not exceed 50 characters')
    .matches(
      /^[a-zA-ZÀ-ỹ\s'-]+$/,
      'Full name can only contain letters, spaces, hyphens, and apostrophes'
    )
    .test(
      'no-numbers',
      'Full name cannot contain numbers',
      (value) => !/\d/.test(value || '')
    )
    .trim('Full name cannot be just spaces'),
  fullAddress: yup
    .string()
    .required('Address is required')
    .min(5, 'Address must be at least 5 characters')
    .max(200, 'Address cannot exceed 200 characters')
    .trim('Address cannot be just spaces'),
  invoiceEmail: yup
    .array()
    .of(yup.string().email('Invalid email'))
    .transform((value, originalValue) => {
      // If originalValue is a string (from input), split it; otherwise, use value
      if (typeof originalValue === 'string') {
        return originalValue
          .split(',')
          .map((email) => email.trim())
          .filter((email) => email);
      }
      return value;
    })
    .required('Invoice emails are required')
    .min(1, 'At least one email is required'),
});

const businessInfoSchema = yup.object({
  taxId: yup
    .string()
    .required('Tax ID is required')
    .matches(/^[0-9]+$/, 'Tax ID must contain only numbers'),
  companyName: yup.string().required('Company name is required'),
  fullAddress: yup
    .string()
    .required('Address is required')
    .min(5, 'Address must be at least 5 characters')
    .max(200, 'Address cannot exceed 200 characters')
    .trim('Address cannot be just spaces'),
  invoiceEmail: yup
    .array()
    .of(yup.string().email('Invalid email'))
    .transform((value, originalValue) => {
      // If originalValue is a string (from input), split it; otherwise, use value
      if (typeof originalValue === 'string') {
        return originalValue
          .split(',')
          .map((email) => email.trim())
          .filter((email) => email);
      }
      return value;
    })
    .required('Invoice emails are required')
    .min(1, 'At least one email is required'),
});

export const billingInfoSchema = yup.object({
  fullName: yup
    .string()
    .required('Full name is required')
    .min(2, 'Full name must be at least 2 characters')
    .max(50, 'Full name must not exceed 50 characters')
    .matches(
      /^[a-zA-ZÀ-ỹ\s'-]+$/,
      'Full name can only contain letters, spaces, hyphens, and apostrophes'
    )
    .test(
      'no-numbers',
      'Full name cannot contain numbers',
      (value) => !/\d/.test(value || '')
    )
    .trim('Full name cannot be just spaces'),
  phone: yup
    .string()
    .required('Phone is required')
    .trim()
    .transform((value) => value.replace(/\s/g, ''))
    .matches(/^(\+84)\d{9}$/, 'Invalid phone number format'),
  email: yup.string().required('Email is required').email('Invalid email'),
  invoiceType: yup.string(),
  invoice: yup.lazy((_, context) => {
    const type = context?.parent?.invoiceType;
    if (type === 'business') return businessInfoSchema;
    return individualInfoSchema;
  }),
});

export const addNewPackageInfoSchema = yup.object({
  invoiceType: yup.string(),
  invoice: yup.lazy((_, context) => {
    const type = context?.parent?.invoiceType;
    if (type === 'business') return businessInfoSchema;
    return businessInfoSchema;
  }),
});

export const manageInvoiceSchema = yup.object({
  type: yup.number().required('Please choose invoice recipient Type'),
  taxId: yup.string().required('Please input information'),
  companyName: yup.string().required('Please input information'),
  address: yup.string().required('Please input information'),
  invoiceEmail: yup
    .array()
    .of(yup.string().email('Invalid email'))
    .min(1, 'At least one invoice email is required')
    .required('Invoice emails are required'),
});

export const saveTemplateSchema = yup.object().shape({
  name: yup.string().required('Please input information'),
  description: yup.string().required('Please input information'),
});

export const emailConfigSchema = yup.object().shape({
  name: yup.string().required('Please input information'),
  smtpServer: yup.string().required('Please input information'),
  smtpPort: yup.number().required('Please input information'),
  smtpUserName: yup.string().required('Please input information'),
  smtpPassword: yup.string().required('Please input information'),
});

export const emailEditConfigSchema = yup.object().shape({
  name: yup.string().required('Please input information'),
  smtpServer: yup.string().required('Please input information'),
  smtpPort: yup.number().required('Please input information'),
  smtpUserName: yup.string().required('Please input information'),
  smtpPassword: yup.string().optional(),
});

export const smsConfigSchema = yup.object().shape({
  name: yup.string().required('Please input information'),
  smsGatewayUrl: yup.string().required('Please input information'),
  smsUserName: yup.string().required('Please input information'),
  smsPassword: yup.string().required('Please input information'),
  senderName: yup.string().required('Please input information'),
});

export const smsEditConfigSchema = yup.object().shape({
  name: yup.string().required('Please input information'),
  smsGatewayUrl: yup.string().required('Please input information'),
  smsUserName: yup.string().required('Please input information'),
  smsPassword: yup.string().optional(),
  senderName: yup.string().required('Please input information'),
});

export const providerConfigSchema = yup.object().shape({
  provider: yup.string().required('Please input information'),
  message: yup.string().required('Please input information'),
  maxOtp: yup.string().required('Please input information'),
  expireTime: yup.string().required('Please input information'),
  maxEntry: yup.string().required('Please input information'),
  emailTemplate: yup.string().required('Please input information'),
});

export const agentConfigsSchema = yup.object({
  agentType: yup.number().required('Please input information'),
  verifyType: yup.number().required('Please input information'),
  userOnboardMsg: yup
    .string()
    .max(500, 'Maximum 500 characters')
    .when('agentType', {
      is: 2,
      then: (schema) => schema.required('Authentication message is required'),
      otherwise: (schema) => schema.optional(),
    }),
  bothOnboardMsg: yup
    .string()
    .max(500, 'Maximum 500 characters')
    .when('agentType', {
      is: 1,
      then: (schema) => schema.required('Authentication message is required'),
      otherwise: (schema) => schema.optional(),
    }),

  mail: yup
    .object({
      expireOtpTime: yup
        .number()
        .min(0, 'Expiry time must be at least 0')
        .typeError('Amount must be a number'),
      maxVerifyOtp: yup
        .number()
        .min(0, 'Max entry must be at least 0')
        .typeError('Amount must be a number'),
      maxOtpDay: yup
        .number()
        .min(0, 'Max OTP per day must be at least 0')
        .typeError('Amount must be a number'),
      emailTemplateId: yup.number(),
      providerId: yup.number(),
    })
    .when(['verifyType', 'agentType'], {
      is: (verifyType: number, agentType: number) =>
        verifyType === 3 && agentType !== 3,
      then: (schema) =>
        schema.required('Email config is required').shape({
          expireOtpTime: yup.number().required('Please input information'),
          maxVerifyOtp: yup.number().required('Please input information'),
          maxOtpDay: yup.number().required('Please input information'),
          emailTemplateId: yup.number().required('Please input information'),
          providerId: yup.number().required('Please input information'),
        }),
      otherwise: (schema) => schema.strip(), // strip = bỏ hẳn field mail nếu không dùng
    }),
  sms: yup
    .object({
      expireOtpTime: yup
        .number()
        .min(0, 'Expiry time must be at least 0')
        .typeError('Amount must be a number'),
      maxVerifyOtp: yup
        .number()
        .min(0, 'Max entry must be at least 0')
        .typeError('Amount must be a number'),
      maxOtpDay: yup
        .number()
        .min(0, 'Max OTP per day must be at least 0')
        .typeError('Amount must be a number'),
      template: yup
        .string()
        .min(10, 'Message must be at least 10 characters')
        .max(200, 'Message must be at most 200 characters')
        .test(
          'contains-otp',
          'Missing OTP placeholder in message.',
          (value) => !value || value.includes('[otp]')
        ),
      providerId: yup.number(),
    })
    .when(['verifyType', 'agentType'], {
      is: (verifyType: number, agentType: number) =>
        verifyType === 2 && agentType !== 3,
      then: (schema) =>
        schema.required('SMS config is required').shape({
          expireOtpTime: yup.number().required('Please input information'),
          maxVerifyOtp: yup.number().required('Please input information'),
          maxOtpDay: yup.number().required('Please input information'),
          template: yup.string().required('SMS verification message is required'),
          providerId: yup.number().required('Please input information'),
        }),
      otherwise: (schema) => schema.strip(),
    }),
});

export const emailTemplateSchema = yup.object({
  emailAddress: yup
    .string()
    .required('From email is required')
    .email('Please enter a valid sender email'),
  fromName: yup.string().required('Please input information'),
  titleTemplate: yup.string().required('Email subject is required'),
  // supportEmail: yup
  //   .string()
  //   .required('Please input information')
  //   .email('Email is invalid'),
  // senderName: yup.string().nullable(),
  bodyMessage: yup.string().nullable(),
  headerLogo: yup.string().required('Header Logo URL is required'),
  footerLogo: yup.string().required('Footer Logo URL is required'),
  location: yup.string().nullable(),
  socials: yup.array().of(
    yup.object({
      socialType: yup.string(),
      url: yup
        .string()
        .required('Must be a valid URL')
        .url('Must be a valid URL'),
    })
  ),
  name: yup.string().required('Please input information'),
  description: yup.string().required('Please input information'),
});

export const budgetSchema = yup.object().shape({
  targetAmount: yup
    .number()
    .typeError('Target amount must be a number')
    .required('Please input information')
    .min(1, 'Target amount must be greater than 0'),

  thresholds: yup.array().of(
    yup.object({
      percent: yup.number().optional(),
      amount: yup.number().optional(),
    })
  ),

  emails: yup.array().of(
    yup.object({
      value: yup.string().email('Invalid email format').optional(),
    })
  ),
});

export const changePlanBillingInfoSchema = yup.object({
  billingInfo: yup.lazy((_, context) => {
    const type = context?.parent?.invoiceType;
    if (type === 2) return businessInfoSchema;
    return individualInfoSchema;
  }),
});

export type BudgetFormValues = yup.InferType<typeof budgetSchema>;

// IPv4 regex
const ipv4Regex = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;

// IPv6 regex
const ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9])?[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9])?[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9])?[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9])?[0-9]))$/;

export const publicApiRequestSchema = yup.object().shape({
  secretKey: yup.string().optional(),
  token: yup.string().optional(),
  webhookUrl: yup
    .string()
    .required('This field is required')
    .url('Invalid webhook format'),
  ipAddress: yup
    .string()
    .test('is-ip', 'Invalid IP format', (value) => {
      if (!value) return true;
      return ipv4Regex.test(value) || ipv6Regex.test(value);
    })
    .optional(),
});

export const zaloBotSchema = yup.object().shape({
  webhookUrl: yup.string().optional(),
  secretToken: yup.string().optional(),
  botToken: yup
    .string()
    .required('Bot token is required')
});

export const triggerCardSchema = yup.object().shape({
  type: yup.number().optional(),
  payload: yup
    .array()
    .test('unique-payload-keys', '', (payload) => {
      if (!payload) return true;
      const seen = new Set();
      const errors: yup.ValidationError[] = [];
      payload.forEach((p, i) => {
        const key = p.key?.trim().toLowerCase();
        if (key && seen.has(key)) {
          errors.push(new yup.ValidationError('Duplicate key', p.key, `payload[${i}].key`));
        } else if (key) {
          seen.add(key);
        }
      });
      return errors.length > 0 ? new yup.ValidationError(errors) : true;
    })
    .when('type', {
      is: 2,
      then: (schema) =>
        schema
          .of(
            yup.object().shape({
              key: yup.string().required('Enter Key'),
              value: yup.string().required('This is required field'),
            })
          )
          .min(1, 'Please add at least one payload')
          .required('This is required field'),
      otherwise: (schema) => schema.notRequired(),
    }),
  channel: yup.string().when('type', {
    is: 2,
    then: (schema) => schema.required('This is required field'),
    otherwise: (schema) => schema.notRequired(),
  }),
  channelContent: yup
    .array()
    .of(yup.string().trim())
    .when('type', {
      is: 2,
      then: (schema) =>
        schema.when('channel', {
          is: (val: string) => ['zalooa', 'facebook', 'whatsapp', 'zalobot'].includes(val),
          then: (subSchema) =>
            subSchema.test(
              'has-non-empty',
              'This is required field',
              (value) => {
                if (!value || !Array.isArray(value)) return false;
                return value.some((item) => item && item.trim() !== '');
              }
            ),
          otherwise: (subSchema) => subSchema.notRequired(),
        }),
      otherwise: (schema) => schema.notRequired(),
    }),
  targetMode: yup.number().when('type', {
    is: 2,
    then: (schema) =>
      schema.when('channel', {
        is: 'website',
        then: (s) => s.required('This is required field'),
        otherwise: (s) => s.notRequired(),
      }),
    otherwise: (schema) => schema.notRequired(),
  }),
  userName: yup.number().when('type', {
    is: 2,
    then: (schema) =>
      schema.when('channel', {
        is: (val: string) => val && val !== 'none',
        then: (s) => s.required('This is required field'),
        otherwise: (s) => s.notRequired(),
      }),
    otherwise: (schema) => schema.notRequired(),
  }),
  userNameContent: yup
    .array()
    .of(yup.string().trim())
    .when('type', {
      is: 2,
      then: (schema) =>
        schema.when('channel', {
          is: (val: string) => val && val !== 'none',
          then: (s) =>
            s.test(
              'has-non-empty',
              'This is required field',
              (value) => {
                if (!value || !Array.isArray(value)) return false;
                return value.some((item) => item && item.trim() !== '');
              }
            ),
          otherwise: (s) => s.optional(),
        }),
      otherwise: (schema) => schema.optional().nullable(),
    }),
  saveResponseVariable: yup.string().optional(),
  action: yup.string().when('type', {
    is: 1,
    then: (schema) =>
      schema
        .required('This is required field')
        .test('starts-with-dot-slash', 'Command must start with /', (value) =>
          (value ? value.startsWith('/') : false))
        .test('no-spaces', 'Command cannot contain spaces', (value) =>
          (value ? !/\s/.test(value) : false)),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export const dataWorkFlowSchema = yup.object({
  name: yup
    .string()
    .required('Please input information')
    .trim()
    .min(1, 'Name must be at least 1 character'),

  datasets: yup
    .array()
    .of(
      yup.object({
        name: yup
          .string()
          .required('Please input information')
          .trim()
          .min(1, 'Dataset name must be at least 1 character'),

        fileName: yup
          .string()
          .required('Please input information')
          .trim()
          .min(1, 'File name must be at least 1 character'),

        fileType: yup
          .string()
          .required('Please input information')
          .oneOf(['xlsx', 'csv'], 'Invalid file type'),

        sheetName: yup
          .string()
          .when('fileType', {
            is: 'xlsx',
            then: (s) => s.required('Please input information'),
            otherwise: (s) => s.optional().trim(),
          })
          .optional()
          .trim()
          .nullable(),

        structures: yup
          .array()
          .of(
            yup.object({
              field: yup
                .string()
                .required('Please input information')
                .trim()
                .min(1, 'Field name must be at least 1 character'),

              type: yup
                .string()
                .required('Please input information')
                .oneOf(['string', 'number', 'date', 'boolean'], 'Invalid type'),
            })
          )
          .min(1, 'At least one structure is required')
          .required('Structures are required')
          .test(
            'unique-structure-field',
            'Column name must be unique',
            (items, { path, createError }) => {
              if (!items) return true;

              const map = new Map<string, number[]>();

              items.forEach((item, i) => {
                const key = item?.field?.trim().toLowerCase();
                if (!key) return;
                if (!map.has(key)) map.set(key, []);
                map.get(key)!.push(i);
              });

              const duplicated = Array.from(map.entries()).filter(
                ([, idxs]) => idxs.length > 1
              );

              if (duplicated.length === 0) return true;

              // Gắn lỗi vào từng item trùng
              duplicated.forEach(([_, idxs]) => {
                idxs.forEach((i) => {
                  createError({
                    path: `${path}[${i}].field`,
                    message: 'Column name must be unique',
                  });
                });
              });

              return false;
            }
          ),
      })
    )
    .min(1, 'At least one dataset is required')
    .required('Please input information')
    .test('unique-dataset-name', 'Dataset name must be unique', (datasets) => {
      if (!datasets) return true;

      const names = datasets.map((d) => d?.name?.trim().toLowerCase());
      const unique = new Set(names);

      return unique.size === names.length;
    }),

  stage: yup
    .array()
    .of(
      yup.object({
        name: yup
          .string()
          .required('Please input information')
          .trim()
          .min(1, 'Stage name must not be empty'),

        stageType: yup.string().required('Please input information'),

        // source: yup.string().when('stageType', {
        //   is: 'filter',
        //   then: (schema) =>
        //     schema.required('Source dataset is required').trim(),
        //   otherwise: (schema) => schema.optional(),
        // }),
        rules: yup.array().when('stageType', {
          is: 'filter',
          then: () =>
            yup.array().of(
              yup.object({
                field: yup.string().required('Please input information'),
                fieldType: yup
                  .mixed<'date' | 'number' | 'string' | 'boolean'>()
                  .oneOf(
                    ['date', 'number', 'string', 'boolean'],
                    'Invalid field type'
                  )
                  .required('Please input information'),

                newField: yup.string().when('createNew', {
                  is: true,
                  then: (s) => s.required('Please input information'),
                  otherwise: (s) => s.optional(),
                }),

                operator: yup
                  .number()
                  .required('Please input information')
                  .integer()
                  .oneOf(
                    [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
                    'Invalid operator'
                  ),

                value1: yup
                  .mixed()
                  .required('Please input information')
                  .test(
                    'valid-by-field-type',
                    'Invalid format. Please check your input.',
                    (v, { parent, createError }) => {
                      const { fieldType } = parent;
                      if (fieldType === 'string') {
                        return typeof v === 'string' && v.trim().length > 0;
                      }

                      if (fieldType === 'number') {
                        if (v === null || v === undefined || v === '') {
                          return createError({
                            message: 'Please input information',
                          });
                        }
                        return !Number.isNaN(Number(v));
                      }

                      if (fieldType === 'boolean') {
                        return (
                          v === true
                          || v === false
                          || v === 'true'
                          || v === 'false'
                        );
                      }

                      if (fieldType === 'date') {
                        // IMPORTANT: only accept strict DD/MM/YYYY string
                        if (typeof v !== 'string') {
                          return createError({
                            message:
                              'Date must be a string in DD/MM/YYYY format',
                          });
                        }
                        if (!/^\d{2}\/\d{2}\/\d{4}$/.test(v)) {
                          return createError({
                            message:
                              'Date must be exactly in DD/MM/YYYY format',
                          });
                        }
                        const ok = dayjs(
                          v as string,
                          'DD/MM/YYYY',
                          true
                        ).isValid();
                        return (
                          ok
                          || createError({ message: 'Invalid calendar date' })
                        );
                      }

                      return false;
                    }
                  ),

                // value2 validator (required and same validation when operator === 8)
                value2: yup.mixed().when('operator', {
                  is: 8,
                  then: (s) =>
                    s
                      .required('Please input information')
                      .test(
                        'valid-by-field-type-2',
                        'Invalid value for field type',
                        (v, { parent, createError }) => {
                          const fieldType = parent?.fieldType;
                          if (fieldType === 'number') {
                            if (v === null || v === undefined || v === '') {
                              return createError({
                                message: 'Please input information',
                              });
                            }
                            return !Number.isNaN(Number(v));
                          }

                          if (fieldType === 'boolean') {
                            return (
                              v === true
                              || v === false
                              || v === 'true'
                              || v === 'false'
                            );
                          }

                          if (fieldType === 'date') {
                            if (typeof v !== 'string') {
                              return createError({
                                message:
                                  'Date must be a string in DD/MM/YYYY format',
                              });
                            }

                            if (!/^\d{2}\/\d{2}\/\d{4}$/.test(v)) {
                              return createError({
                                message:
                                  'Date must be exactly in DD/MM/YYYY format',
                              });
                            }

                            const d2 = dayjs(v as string, 'DD/MM/YYYY', true);
                            if (!d2.isValid()) {
                              return createError({
                                message: 'Invalid calendar date',
                              });
                            }

                            const from = parent?.value1;
                            if (
                              typeof from === 'string'
                              && /^\d{2}\/\d{2}\/\d{4}$/.test(from)
                            ) {
                              const d1 = dayjs(from, 'DD/MM/YYYY', true);
                              if (!d2.isAfter(d1)) {
                                return createError({
                                  message:
                                    'End date must be greater than start date',
                                });
                              }
                            }

                            return true;
                          }

                          return typeof v === 'string' && v.trim().length > 0;
                        }
                      ),
                  otherwise: (s) => s.optional(),
                }),

                createNew: yup.boolean().optional(),
              })
            ),

          otherwise: (schema) =>
            schema.when('stageType', {
              is: 'join',
              then: () =>
                yup
                  .array()
                  .of(
                    yup.object({
                      value1: yup.string().required('Please input information'),
                      value2: yup.string().required('Please input information'),
                      datasetName: yup
                        .string()
                        .required('Please input information'),
                    })
                  ) // ⭐⭐ THÊM TEST UNIQUE CHO value2 Ở ĐÂY ⭐⭐
                  .test(
                    'unique-value2-join',
                    'New name field values cannot be duplicated',
                    (rules, { createError, path }) => {
                      if (!rules) return true;

                      const list = rules
                        .map((r) => r?.value2)
                        .filter(
                          (v) =>
                            v !== undefined
                            && v !== null
                            && `${v}`.trim() !== ''
                        )
                        .map((v) => `${v}`.trim());

                      const unique = new Set(list);

                      if (unique.size !== list.length) {
                        return createError({
                          path,
                          message: 'New name field values cannot be duplicated',
                        });
                      }

                      return true;
                    }
                  ),
              otherwise: () =>
                yup.array().of(
                  yup.object({
                    // TRANSFORM
                    field: yup.string().required('Please input information'),
                    fieldType: yup
                      .string()
                      .required('Please input information'),
                    operator: yup
                      .number()
                      .required('Please input information')
                      .integer(),

                    value1: yup.mixed().when('operator', {
                      is: 11,
                      then: (s) => s.required('Please input information'),
                      otherwise: (s) => s.optional(),
                    }),

                    value2: yup.mixed().when('operator', {
                      is: 11,
                      then: (s) => s.required('Please input information'),
                      otherwise: (s) => s.optional(),
                    }),

                    newField: yup.mixed().when('createNew', {
                      is: true,
                      then: (s) => s.required('Please input information'),
                      otherwise: (s) => s.optional(),
                    }),

                    createNew: yup.boolean().optional(),
                  })
                ),
            }),
        }),

        // Other stage fields...
        joinType: yup.string().when('stageType', {
          is: 'join',

          then: (schema) => schema.required('Please input information'),
          otherwise: (schema) => schema.optional(),
        }),

        dataset: yup.string().when('stageType', {
          is: (type: string) => type === 'join' || type === 'filter',
          then: (schema) => schema.required('Please input information'),
          otherwise: (schema) => schema.optional(),
        }),
        dataset2: yup.string().when('stageType', {
          is: 'join',
          then: (schema) => schema.required('Please input information'),
          otherwise: (schema) => schema.optional(),
        }),

        joinKey1: yup.string().optional(),

        joinKey2: yup.string().optional(),

        newDataset: yup.string().when('stageType', {
          is: 'join',
          then: (schema) => schema.required('Please input information').trim(),
          otherwise: (schema) => schema.optional(),
        }),

        fileName: yup.string().required('Please input information'),
        fileType: yup.string().required('Please input information'),
      })
    )
    .min(1, 'At least one stage is required')
    .required('Please input information')
    .test('unique-stage-name', 'Stage name must be unique', (stages) => {
      if (!stages) return true;

      const names = stages.map((s) => s?.name?.trim().toLowerCase());
      const unique = new Set(names);

      return unique.size === names.length;
    }),

  output: yup.array().of(
    yup.object({
      fileType: yup.string().required('Please input information'),
      outputFileName: yup.string().required('Please input information'),
    })
  ),
  // .min(1, 'At least one stage is required')
  // .required('Please input information'),
});

export const dataETLSchema = yup.object().shape({
  content: yup
    .string()
    .required('Please input information'),
  saveResponseVariable: yup
    .string()
    .required('Please input information'),
  actionCode: yup
    .string()
    .required('Please input information'),
});

export const createToolSchema = yup.object({
  name: yup
    .string()
    .trim()
    .required('Name is required')
    .min(1, 'Name must not be empty')
    .max(100, 'Maximum 100 characters'),

  description: yup
    .string()
    .trim()
    .required('Required field cannot be empty')
    .min(1, 'Description must not be empty')
    .max(500, 'Maximum 500 characters'),

  // toolExecution: yup.object({
  //   preToolSpeech: yup
  //     .string(),
  //   mode: yup
  //     .string(),
  //   toolSoundId: yup
  //     .number()
  // }).required('Tool execution is required'),

  apiConfig: yup.object({
    method: yup
      .string()
      .trim()
      .required('Method is required')
      .min(1, 'Method must not be empty'),

    url: yup
      .string()
      .trim()
      .required('URL is required')
      .matches(/^(http|https):\/\//, 'Enter a valid URL')
      .matches(/^\S+$/, 'No spaces allowed')
      .max(2000, 'Must be ≤2000 chars'),

    timeout: yup
      .number()
      .typeError('Timeout must be a number between 0 and 120000')
      .required('Timeout is required')
      .integer('Timeout must be a number between 0 and 120000')
      .min(0, 'Timeout must be a number between 0 and 120000')
      .max(600000, 'Timeout must be a number between 0 and 120000'),
  }).required('API config is required'),

  // tempBodyParams: yup.array().of(
  //   yup.object({
  //     identifier: yup.string()
  //       .max(30, 'Maximum 30 characters')
  //       .matches(/^(?![0-9]+$)[a-zA-Z0-9_-]+$/, 'Identifier is invalid'),
  //     description: yup.string().max(500, 'Maximum 500 characters'),
  //     enumValues: yup.string().max(200, 'Maximum 200 characters'),
  //   })
  // ).test('unique-temp-identifier', '', (params) => {
  //   if (!params) return true;
  //   const seen = new Set();
  //   const errors: yup.ValidationError[] = [];
  //   params.forEach((p, i) => {
  //     const id = p.identifier?.trim();
  //     const normalizedId = id?.toLowerCase();
  //     if (normalizedId && seen.has(normalizedId)) {
  //       errors.push(new yup.ValidationError('Identifier already exists', id, `tempBodyParams[${i}].identifier`));
  //     } else if (normalizedId) {
  //       seen.add(normalizedId);
  //     }
  //   });
  //   if (errors.length > 0) return new yup.ValidationError(errors);
  //   return true;
  // }),
  bodyParams: yup.array().of(
    yup.object({
      identifier: yup.string()
        .max(30, 'Maximum 30 characters')
        .matches(/^(?![0-9]+$)[a-zA-Z0-9_-]+$/, 'Identifier is invalid'),
      valueType: yup.number(),
      description: yup.string()
        .max(500, 'Maximum 500 characters')
        .nullable()
        .when('valueType', {
          is: 1,
          then: (schema) => schema.required('Description is required'),
          otherwise: (schema) => schema.optional(),
        }),
      enumValues: yup.string().nullable()
      // enumValues: yup.string().max(200, 'Maximum 200 characters').nullable()

    })
  ).test('unique-body-identifier', '', (params) => {
    if (!params) return true;
    const seen = new Set();
    const errors: yup.ValidationError[] = [];
    params.forEach((p, i) => {
      const id = p.identifier?.trim();
      const normalizedId = id?.toLowerCase();
      if (normalizedId && seen.has(normalizedId)) {
        errors.push(new yup.ValidationError('Identifier already exists', id, `bodyParams[${i}].identifier`));
      } else if (normalizedId) {
        seen.add(normalizedId);
      }
    });
    if (errors.length > 0) return new yup.ValidationError(errors);
    return true;
  }),

  header: yup
    .array()
    .of(
      yup.object({
        key: yup
          .string()
          .trim()
          .required('Key is required')
          .min(1, 'Key must not be empty')
          .matches(/^[A-Za-z0-9_-]+$/, 'Header key contains invalid characters'),

        value: yup
          .string()
          .required('Value is required')
          .min(1, 'Value must not be empty')
          .test('no-invalid-chars', 'Header value contains invalid characters', (val) => {
            if (!val) return true;
            // Chặn cả ký tự newline/tab thực tế và chuỗi ký tự "\n", "\r", "\t"
            const hasActualControlChar = /[\n\r\t]/.test(val);
            const hasLiteralEscape = /\\n|\\r|\\t/.test(val);
            return !hasActualControlChar && !hasLiteralEscape;
          }),
      })
    )
    .required('Headers are required')
    .min(1, 'At least one header is required')
    .test('unique-header-keys', '', (headers) => {
      if (!headers) return true;
      const seen = new Set();
      const errors: yup.ValidationError[] = [];
      headers.forEach((h, i) => {
        const key = h.key.trim();
        const normalizedKey = key.toLowerCase();
        if (seen.has(normalizedKey) && normalizedKey !== '') {
          errors.push(new yup.ValidationError('Header key already exists', key, `header[${i}].key`));
        } else {
          seen.add(normalizedKey);
        }
      });
      if (errors.length > 0) {
        return new yup.ValidationError(errors);
      }
      return true;
    }),

  responseVariables: yup
    .array()
    .of(
      yup.object({
        key: yup
          .string()
          .trim()
          .required('Key is required')
          .min(1, 'Key must not be empty'),

        value: yup
          .string()
          .trim()
          .required('Value is required')
          .min(1, 'Value must not be empty'),
      })
    )
    .required('Response variables are required')
    .min(1, 'At least one response variable is required')
    .test(
      'unique-response-keys',
      '',
      (items) => {
        if (!items || items.length === 0) return true;

        const seen = new Set<string>();
        const errors: yup.ValidationError[] = [];

        items.forEach((item, idx) => {
          const key = item.key.trim();
          const normalizedKey = key.toLowerCase();

          if (normalizedKey === '') return;

          if (seen.has(normalizedKey)) {
            errors.push(
              new yup.ValidationError(
                'Variable name already exists.',
                item.key,
                `responseVariables[${idx}].key`
              )
            );
          } else {
            seen.add(normalizedKey);
          }
        });

        if (errors.length > 0) {
          return new yup.ValidationError(errors);
        }

        return true;
      }
    ),
});

export const configConditionSchema = yup.object({
  transitionType: yup.string().required('Please choose a transaction type'),
  label: yup.string().required('Please input information'),
  condition: yup.string().required('Please input information'),
});

export const startCardSchema = yup.object({
  voiceLink: yup.string().required('Please choose a voice'),
  message: yup.string().required('Please input information'),
});

export const subAgentCardSchema = yup.object({
  voiceLink: yup.string().required('Please choose a voice'),
  name: yup.string().required('Please input information'),
  instruction: yup.string().required('Please input information'),
  forNavigation: yup.boolean().optional(),
});

export const addDataRetrievalSchema = yup.object({
  type: yup.number().required('Please choose a type'),
  name: yup.string().required('Please input information'),
  description: yup.string().required('Please input information'),
});

export const addSkillSchema = yup.object().shape({
  name: yup.string().when('$isDefault', {
    is: true,
    then: (schema) => schema.optional(),
    otherwise: (schema) => schema.required('This field is required').max(60, 'Skill name must be 60 characters or fewer'),
  }),
  whenToUse: yup.string().nullable().when('$isDefault', {
    is: true,
    then: (schema) => schema.optional(),
    otherwise: (schema) => schema.required('This field is required')
    // .max(500, 'When to use must be 500 characters or fewer'),
  }),
  instruction: yup
    .string()
    .required('This field is required')
    .max(8000, 'Instruction must be 8000 characters or fewer'),
  knowledgeType: yup.string().oneOf(['selected', 'group', 'general']).required(),
  knowledge: yup.array().when(['knowledgeType', '$isDefault'], ([knowledgeType, isDefault], schema) => (
    !isDefault && knowledgeType === 'selected'
      ? schema.min(1, 'Please add at least one file (or tag), or switch to "AI general knowledge only"')
      : schema.optional()
  )),
  dataTags: yup.array().when(['knowledgeType', '$isDefault'], ([knowledgeType, isDefault], schema) => (
    !isDefault && knowledgeType === 'group'
      ? schema.min(1, 'Please add at least one file (or tag), or switch to "AI general knowledge only"')
      : schema.optional()
  )),
  tools: yup.array().optional(),
});
